import { useContext } from 'react'
import { useSelector } from 'react-redux'

import { useForm, useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import defaultState, { requiredFields } from '@models/providerDisclaimer'

import * as providerDisclaimerActions from '@redux/modules/providerDisclaimer'

export const generateUrls = (providerDisclaimer = {}) => {
  const { provider_id } = providerDisclaimer

  return {
    editProviderUrl: `#/systemManager/providers/${provider_id}/edit`,
  }
}

const createProviderDisclaimer = (params) => {
  const { providerDisclaimerParams, dispatch, requestOptions } = params
  const { createProviderDisclaimer: createFn } = providerDisclaimerActions

  return dispatch(createFn(providerDisclaimerParams, requestOptions))
}

const updateProviderDisclaimer = (params) => {
  const { providerDisclaimerParams, dispatch, requestOptions } = params
  const { updateProviderDisclaimer: updateFn } = providerDisclaimerActions

  return dispatch(updateFn(providerDisclaimerParams, requestOptions))
}

const deleteProviderDisclaimer = (params) => {
  const { providerDisclaimer, dispatch } = params
  const { deleteProviderDisclaimer: deleteFn } = providerDisclaimerActions

  return dispatch(deleteFn(providerDisclaimer))
}

const createOrEditProviderDisclaimer = params => new Promise((resolve, reject) => {
  const { providerDisclaimer, showCreateOrEditProviderDisclaimerModal } = params

  if (showCreateOrEditProviderDisclaimerModal){
    const payload = {
      providerDisclaimer,
    }

    showCreateOrEditProviderDisclaimerModal(payload)

    resolve({ success: true, result: payload })
  }

  reject(new Error('showCreateOrEditProviderDisclaimerModal not defined in PageContext callbacks'))
})

export function useProviderDisclaimerForm(providerDisclaimer = {}, options = {}){
  const { validateOn } = options

  const providerDisclaimerForm = useForm(
    defaultState,
    { entity: providerDisclaimer, requiredFields, validateOn },
    [providerDisclaimer.id, providerDisclaimer.cache_key],
  )

  return {
    ...providerDisclaimerForm,
  }
}

export function useRelations(providerDisclaimer = {}){
  const { entity_id } = providerDisclaimer

  const serviceProducts = useSelector(reduxState => reduxState.entities.serviceProducts)

  const serviceProduct = serviceProducts[entity_id] || {}

  return {
    serviceProduct,
  }
}

function useProviderDisclaimer(initEntity = {}){
  const { callbacks } = useContext(PageContext)
  const { showCreateOrEditProviderDisclaimerModal } = callbacks || {}

  const { entity: providerDisclaimer } = useLatestEntity(initEntity, 'providerDisclaimers')
  const dispatch = useThunkDispatch()

  const {
    creating, deleting, loading, updating,
  } = useSelector(reduxState => reduxState.providerDisclaimers)

  return {
    callbacks: {
      createOrEditProviderDisclaimer: () => createOrEditProviderDisclaimer({
        providerDisclaimer, showCreateOrEditProviderDisclaimerModal,
      }),
      createProviderDisclaimer: (providerDisclaimerParams, requestOptions) => createProviderDisclaimer({
        providerDisclaimerParams, dispatch, requestOptions,
      }),
      deleteProviderDisclaimer: () => deleteProviderDisclaimer({
        providerDisclaimer, dispatch,
      }),
      updateProviderDisclaimer: (providerDisclaimerParams, requestOptions) => updateProviderDisclaimer({
        providerDisclaimerParams, dispatch, requestOptions,
      }),
    },
    creating,
    deleting,
    loading,
    updating,
    providerDisclaimer,
  }
}

export default useProviderDisclaimer
